import React, { useEffect } from 'react';
import { XIcon, MoonIcon } from 'lucide-react';
export const ExitPopup = ({
  onClose
}) => {
  useEffect(() => {
    // Prevent scrolling when popup is open
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = 'auto';
    };
  }, []);
  return <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50" data-id="element-191">
      <div className="bg-white rounded-lg shadow-xl p-6 max-w-md w-full mx-4 relative animate-scaleIn" data-id="element-192">
        <button onClick={onClose} className="absolute top-3 right-3 text-gray-500 hover:text-gray-700" aria-label="Close popup" data-id="element-193">
          <XIcon className="h-5 w-5" data-id="element-194" />
        </button>
        <div className="flex items-center justify-center mb-4" data-id="element-195">
          <div className="bg-indigo-100 rounded-full p-3" data-id="element-196">
            <MoonIcon className="h-8 w-8 text-indigo-600" data-id="element-197" />
          </div>
        </div>
        <h3 className="text-xl font-bold text-center text-indigo-900 mb-3" data-id="element-198">
          Wait! Don't Let Another Sleepless Night Win
        </h3>
        <p className="text-gray-700 mb-4 text-center" data-id="element-199">
          Get 15% off your first order of Setu's Sleep Restore Melatonin Strips.
          Join thousands who've ditched sleeping pills for better, natural
          sleep.
        </p>
        <div className="bg-indigo-50 p-3 rounded-md text-center mb-6" data-id="element-200">
          <p className="text-indigo-800 font-medium" data-id="element-201">
            Use code <span className="font-bold text-indigo-900" data-id="element-202">SLEEP15</span>{' '}
            - Limited time offer
          </p>
        </div>
        <a href="#buy-now" className="block bg-green-500 hover:bg-green-600 text-white py-3 rounded-full font-bold text-center transition-colors" onClick={onClose} data-id="element-203">
          Claim My Discount
        </a>
        <button onClick={onClose} className="mt-4 text-gray-500 hover:text-gray-700 text-sm text-center w-full" data-id="element-204">
          No thanks, I prefer sleepless nights
        </button>
      </div>
    </div>;
};